/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * コイン獲得・使用履歴の概要を表します。
 * @export
 * @interface UserPointHistoriesSummaryModel
 */
export interface UserPointHistoriesSummaryModel {
    /**
     * 獲得・使用するポイント数
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    point?: number;
    /**
     * ポイントの期限切れされる日付時刻のUNIX時間
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    expireDatetime?: number;
    /**
     * レンタル期限のUNIX時間
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    rentalPeriod?: number;
    /**
     * 獲得・使用した日付時刻のUNIX時間
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    chargedDatetime?: number;
    /**
     * コイン獲得・使用・期限切れの詳細
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    description?: string;
    /**
     * コイン獲得・使用履歴の詳細
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    title?: string;
    /**
     * ボーナスチケット枚数
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    bonusTicket?: number;
    /**
     * 有料ポイント
     * @type {number}
     * @memberof UserPointHistoriesSummaryModel
     */
    chargedPoint?: number;
    /**
     * チャージした履歴かどうかのフラグ
     * @type {boolean}
     * @memberof UserPointHistoriesSummaryModel
     */
    isCharged?: boolean;
    /**
     * ミッションからの履歴かどうかのフラグ
     * @type {boolean}
     * @memberof UserPointHistoriesSummaryModel
     */
    isMission?: boolean;
    /**
     * ポイントタイプはチケットどうかのフラグ
     * @type {boolean}
     * @memberof UserPointHistoriesSummaryModel
     */
    isTicket?: boolean;
    /**
     * 有効期限が切れているどうかのフラグ
     * @type {boolean}
     * @memberof UserPointHistoriesSummaryModel
     */
    isExpired?: boolean;
    /**
     * 付与されたボーナスかどうかのフラグ
     * @type {boolean}
     * @memberof UserPointHistoriesSummaryModel
     */
    isGifted?: boolean;
    /**
     * 購入した作品のリンク先
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    seriesUrl?: string;
    /**
     * 購入したエピソードのリンク先
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    articleUrl?: string;
    /**
     * 購入した作品のタイトル
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    seriesTitle?: string;
    /**
     * 購入したエピソードののタイトル
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    articleTitle?: string;
    /**
     * 購入した作品のID
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    seriesId?: string;
    /**
     * 購入したエピソードのID
     * @type {string}
     * @memberof UserPointHistoriesSummaryModel
     */
    articleId?: string;
}

/**
 * Check if a given object implements the UserPointHistoriesSummaryModel interface.
 */
export function instanceOfUserPointHistoriesSummaryModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserPointHistoriesSummaryModelFromJSON(json: any): UserPointHistoriesSummaryModel {
    return UserPointHistoriesSummaryModelFromJSONTyped(json, false);
}

export function UserPointHistoriesSummaryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointHistoriesSummaryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'point': !exists(json, 'point') ? undefined : json['point'],
        'expireDatetime': !exists(json, 'expireDatetime') ? undefined : json['expireDatetime'],
        'rentalPeriod': !exists(json, 'rentalPeriod') ? undefined : json['rentalPeriod'],
        'chargedDatetime': !exists(json, 'chargedDatetime') ? undefined : json['chargedDatetime'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'bonusTicket': !exists(json, 'bonusTicket') ? undefined : json['bonusTicket'],
        'chargedPoint': !exists(json, 'chargedPoint') ? undefined : json['chargedPoint'],
        'isCharged': !exists(json, 'isCharged') ? undefined : json['isCharged'],
        'isMission': !exists(json, 'isMission') ? undefined : json['isMission'],
        'isTicket': !exists(json, 'isTicket') ? undefined : json['isTicket'],
        'isExpired': !exists(json, 'isExpired') ? undefined : json['isExpired'],
        'isGifted': !exists(json, 'isGifted') ? undefined : json['isGifted'],
        'seriesUrl': !exists(json, 'seriesUrl') ? undefined : json['seriesUrl'],
        'articleUrl': !exists(json, 'articleUrl') ? undefined : json['articleUrl'],
        'seriesTitle': !exists(json, 'seriesTitle') ? undefined : json['seriesTitle'],
        'articleTitle': !exists(json, 'articleTitle') ? undefined : json['articleTitle'],
        'seriesId': !exists(json, 'seriesId') ? undefined : json['seriesId'],
        'articleId': !exists(json, 'articleId') ? undefined : json['articleId'],
    };
}

export function UserPointHistoriesSummaryModelToJSON(value?: UserPointHistoriesSummaryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'point': value.point,
        'expireDatetime': value.expireDatetime,
        'rentalPeriod': value.rentalPeriod,
        'chargedDatetime': value.chargedDatetime,
        'description': value.description,
        'title': value.title,
        'bonusTicket': value.bonusTicket,
        'chargedPoint': value.chargedPoint,
        'isCharged': value.isCharged,
        'isMission': value.isMission,
        'isTicket': value.isTicket,
        'isExpired': value.isExpired,
        'isGifted': value.isGifted,
        'seriesUrl': value.seriesUrl,
        'articleUrl': value.articleUrl,
        'seriesTitle': value.seriesTitle,
        'articleTitle': value.articleTitle,
        'seriesId': value.seriesId,
        'articleId': value.articleId,
    };
}

